var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraduates({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 34.918,
    viewBox: "0 0 48 34.918",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graduates",
    transform: "translate(-1 -9.625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46072",
    "data-name": "Group 46072",
    transform: "translate(16.302 9.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87362",
    "data-name": "Path 87362",
    d: "M21.873,14.011l4.256,1.269.075,1.195a8.517,8.517,0,0,1,3.882-.747,8.358,8.358,0,0,1,3.957.821l.075-1.195,1.867-.6v1.12l-.6.821a.449.449,0,0,0-.075.3v1.941a.43.43,0,0,0,.448.448h1.493a.43.43,0,0,0,.448-.448V17a.449.449,0,0,0-.075-.3l-.821-.821V14.385l1.269-.373c.224-.075.3-.224.373-.448a.409.409,0,0,0-.3-.448L30.161,9.681a.339.339,0,0,0-.373,0L21.8,13.115a.614.614,0,0,0-.3.448.473.473,0,0,0,.373.448Z",
    transform: "translate(-21.5 -9.625)",
    fill: "#D42941"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46073",
    "data-name": "Group 46073",
    transform: "translate(20.784 16.678)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87363",
    "data-name": "Path 87363",
    d: "M34.967,19.765c-1.419-.971-6.047-.9-7.018.075-.075.075-.075.149-.149.224-1.12,3.21,1.12,6.719,3.658,6.719s4.853-3.509,3.658-6.794C35.191,19.915,35.116,19.84,34.967,19.765Z",
    transform: "translate(-27.503 -19.074)",
    fill: "#D42941"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46074",
    "data-name": "Group 46074",
    transform: "translate(15.929 24.311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87364",
    "data-name": "Path 87364",
    d: "M37.873,36.169a4.28,4.28,0,0,1,1.045-.3l-.224-3.21c-.149-.9-.3-1.941-1.568-2.314a10.669,10.669,0,0,0-3.21-.821.556.556,0,0,0-.523.224.494.494,0,0,0-.075.448c.6,2.016.523,4.032-1.867,6.719l-.224-3.36h.224a.43.43,0,0,0,.448-.448V31.316a.43.43,0,0,0-.448-.448H28.466a.43.43,0,0,0-.448.448v1.568a.43.43,0,0,0,.448.448h.3l-.224,3.36C26.152,34,26,31.913,26.674,29.972a.494.494,0,0,0-.075-.448.992.992,0,0,0-.523-.224,12.6,12.6,0,0,0-3.21.821c-1.344.373-1.493,1.419-1.568,2.314L21,35.8c.373.075.672.224,1.045.3,1.792.672,2.986.747,3.36,3.658,0,.075.149,2.538.149,2.389h8.81c0-.075.149-2.538.149-2.389.448-2.837,1.717-2.986,3.36-3.584Z",
    transform: "translate(-21 -29.3)",
    fill: "#D42941"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46075",
    "data-name": "Group 46075",
    transform: "translate(2.045 17.015)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87365",
    "data-name": "Path 87365",
    d: "M2.773,23.911l1.269.448v1.493l-.672.747a.449.449,0,0,0-.075.3v1.941a.43.43,0,0,0,.448.448H5.237a.43.43,0,0,0,.448-.448V26.9a.449.449,0,0,0-.075-.3l-.672-.821V24.583l1.867.6.075,1.195a8.194,8.194,0,0,1,3.957-.821,8.693,8.693,0,0,1,3.882.747l.075-1.195,4.256-1.269c.224-.075.3-.224.373-.448a.409.409,0,0,0-.3-.448l-8.063-3.36a.333.333,0,0,0-.373,0L2.7,23.015a.614.614,0,0,0-.3.448.473.473,0,0,0,.373.448Z",
    transform: "translate(-2.4 -19.525)",
    fill: "#D42941"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46076",
    "data-name": "Group 46076",
    transform: "translate(6.425 24.068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87366",
    "data-name": "Path 87366",
    d: "M15.832,29.74c-.971-.971-5.6-1.045-7.018-.075l-.224.224c-1.195,3.285,1.12,6.794,3.658,6.794s4.853-3.509,3.658-6.719C15.982,29.889,15.907,29.815,15.832,29.74Z",
    transform: "translate(-8.267 -28.974)",
    fill: "#D42941"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46077",
    "data-name": "Group 46077",
    transform: "translate(1 31.701)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87367",
    "data-name": "Path 87367",
    d: "M17.575,40.1a10.668,10.668,0,0,0-3.21-.821.556.556,0,0,0-.523.224.359.359,0,0,0-.149.448c.6,1.941.523,4.032-1.867,6.719l-.224-3.36h.3a.43.43,0,0,0,.448-.448V41.29a.43.43,0,0,0-.448-.448H8.914a.43.43,0,0,0-.448.448v1.493a.43.43,0,0,0,.448.448h.3l-.224,3.36C6.6,43.9,6.45,41.888,7.122,39.872a.494.494,0,0,0-.075-.448.992.992,0,0,0-.523-.224,12.6,12.6,0,0,0-3.21.821c-1.344.373-1.493,1.419-1.568,2.314L1,51.519a.57.57,0,0,0,.149.373.57.57,0,0,0,.373.149H19.366c.149,0,.224-.075.373-.149a.57.57,0,0,0,.149-.373l-.6-9.034c-.3-.9-.448-1.941-1.717-2.389Z",
    transform: "translate(-1 -39.2)",
    fill: "#D42941"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46078",
    "data-name": "Group 46078",
    transform: "translate(30.783 17.015)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87368",
    "data-name": "Path 87368",
    d: "M40.9,23.463a.473.473,0,0,0,.373.448l4.256,1.269.075,1.195a8.517,8.517,0,0,1,3.882-.747,8.358,8.358,0,0,1,3.957.821l.075-1.195,1.867-.6v1.195l-.821.747a.449.449,0,0,0-.075.3v1.941a.43.43,0,0,0,.448.448h1.493a.43.43,0,0,0,.448-.448V26.9a.449.449,0,0,0-.075-.3l-.672-.821V24.285l1.269-.373c.224-.075.3-.224.373-.448a.409.409,0,0,0-.3-.448l-7.989-3.434a.339.339,0,0,0-.373,0l-7.989,3.434a.638.638,0,0,0-.224.448Z",
    transform: "translate(-40.9 -19.525)",
    fill: "#D42941"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46079",
    "data-name": "Group 46079",
    transform: "translate(35.34 24.068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87369",
    "data-name": "Path 87369",
    d: "M54.467,29.665c-1.419-.971-6.047-.9-7.018.075-.075.075-.075.149-.149.224-1.12,3.21,1.12,6.719,3.658,6.719s4.853-3.509,3.658-6.794C54.616,29.815,54.542,29.74,54.467,29.665Z",
    transform: "translate(-47.003 -28.974)",
    fill: "#D42941"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46080",
    "data-name": "Group 46080",
    transform: "translate(30.111 31.701)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87370",
    "data-name": "Path 87370",
    d: "M58.068,42.485c-.149-.9-.3-1.941-1.643-2.389a10.668,10.668,0,0,0-3.21-.821.556.556,0,0,0-.523.224.494.494,0,0,0-.075.448c.6,2.016.523,4.032-1.867,6.719l-.3-3.36h.3a.43.43,0,0,0,.448-.448V41.29a.43.43,0,0,0-.448-.448H47.765a.43.43,0,0,0-.448.448v1.493a.43.43,0,0,0,.448.448h.3l-.224,3.36C45.45,43.9,45.3,41.813,45.973,39.872a.494.494,0,0,0-.075-.448.992.992,0,0,0-.523-.224,12.6,12.6,0,0,0-3.21.821c-1.344.373-1.493,1.419-1.568,2.314L40,51.37a.51.51,0,0,0,.523.523H58.366c.149,0,.224-.075.373-.149a.57.57,0,0,0,.149-.373Z",
    transform: "translate(-40 -39.2)",
    fill: "#D42941"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduates);
export default __webpack_public_path__ + "static/media/graduates.917180b29c9e49396993f99ff03ca8cd.svg";
export { ForwardRef as ReactComponent };